import { useEffect, useState } from 'react'

type TokenJson = {
  chainId: number
  address: string
  name: string
  symbol: string
  decimals: number
  logoURI: string
  introduction?: string
  twitter?: string
  circulatingSupply?: number
}

type VerifyStatsJson = {
  [key: string]: {
    verifiedTokenList: Pick<TokenJson, 'address'>[]
    verifiedIcon: string
  }
}

export enum JsonFilePath {
  TOKENLIST = 'tokenlist.json',
  TOKENLIST_MAINNET = 'tokenlist-mainnet.json',
  VERIFY_STATS = 'verify-stats.json',
}
// todo: the data is all form the mainnet,do not know when it will return the testnet data
export const TOKENLIST =
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development'
    ? JsonFilePath.TOKENLIST_MAINNET
    : JsonFilePath.TOKENLIST
const BASE_URL = 'https://raw.githubusercontent.com/MXCzkEVM/wannseeswap-tokenlist/main/'

export const BASE_CHAIN_ID = process.env.REACT_APP_CHAIN_ID // 18686 | 5167003

/**
 *
 * @param jsonFilePath the jsonFilePath to fetch
 * @param address the current token address (optional:when address is not provided,it means fetch the verify-stats.json)
 * @returns the token information from the github
 * @notice the github address : https://github.com/MXCzkEVM/wannseeswap-tokenlist
 */
const useGithubJson = (jsonFilePath: JsonFilePath, address?: string): { jsonData: TokenJson | VerifyStatsJson } => {
  const [jsonData, setJsonData] = useState<TokenJson | VerifyStatsJson>()

  useEffect(() => {
    let isMounted = true
    fetch(`${BASE_URL}${jsonFilePath}`)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok')
        return response.json()
      })
      .then((data) => {
        if (jsonFilePath === JsonFilePath.VERIFY_STATS) {
          const formatData = data
          formatData[BASE_CHAIN_ID].verifiedTokenList = formatData[BASE_CHAIN_ID].verifiedTokenList.map((i: string) =>
            i.toLowerCase()
          )
          if (isMounted) setJsonData(formatData)
        } else {
          const matchingToken = data.tokens.find((i: TokenJson) => i.address.toLowerCase() === address)
          if (isMounted) setJsonData(matchingToken)
        }
      })
      .catch((error) => {
        console.error(error)
      })
    return () => {
      isMounted = false
    }
  }, [address, jsonFilePath])

  return {
    jsonData,
  }
}

export default useGithubJson
